import { render, staticRenderFns } from "./logos.vue?vue&type=template&id=7d1b2564&scoped=true&"
import script from "./logos.vue?vue&type=script&lang=js&"
export * from "./logos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1b2564",
  null
  
)

export default component.exports